import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fade,
  IconButton,
  Typography,
} from '@material-ui/core';
import { ModalProps } from './__types';
import './index.scss';
import CloseIconModal from 'assets/icons/CloseIconModal';

export const Modal = ({
  title,
  content,
  close,
  open,
  handleBack,
  confirmContent,
  cancelContent,
  onConfirm
}: ModalProps) => {
  return (
    <>
      <Dialog
        open={open}
        onClose={close}
        aria-labelledby='form-dialog-title'
        className='form-dialog-escolas'
        fullWidth={true}
        maxWidth='sm'
        TransitionComponent={Fade}
        transitionDuration={{
          enter: 350,
        }}
      >
        <DialogTitle className='form-dialog-title-modal' id='form-dialog-title'>
          <div className='titleContainer'>
            <Typography className='titleModal'>{title}</Typography>
            <IconButton
              aria-label='close'
              className='closeButton'
              onClick={close}
            >
              <CloseIconModal />
            </IconButton>
          </div>
          <div className='titleLine'></div>
        </DialogTitle>
        <DialogContent>{content}</DialogContent>
        <DialogActions className='dialog-actions'>
          <Button className='btnClose' onClick={close}>
            {cancelContent ?? 'Cancelar'}
          </Button>
          <Button
            className='btnExit'
            onClick={() => {
              if (onConfirm) {
                onConfirm();
              } else {
                handleBack?.()
              }
            }}
          >
            {confirmContent ?? 'Sair'}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
